export default "__VITE_ASSET__e3e236d3__"